import { Assign } from '/api/tools'
import { 
	START_LOADING, 
	CLOSE_LOADING, 
	RESET,
	SET_ACTIVE,
	UPDATE_CART
} from '../action'


const globalDataStructure = {
	loading: false,
	panes: [],
	activeKey: '',
	cartlist: {}
}

export const GlobalReducer = (state = globalDataStructure, action) => {
	switch(action.type){
		
		case START_LOADING: return Assign(state, { loading: true })
		case CLOSE_LOADING: return Assign(state, { loading: false })

		case SET_ACTIVE: return Assign(state, { activeKey: action.key })

		case UPDATE_CART: return Assign(state, { cartlist: action.data })


		case RESET: return globalDataStructure

		default: return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/globalReducers.js